export const PauseIcon: React.FC<any> = ({ className }) => {
    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="inherit">
        <g clip-path="url(#clip0_1987_889)">
            <path d="M4.01579 0.875C3.4743 0.875 2.955 1.07474 2.57211 1.43028C2.18922 1.78581 1.97412 2.26803 1.97412 2.77083V11.9792C1.97412 12.482 2.18922 12.9642 2.57211 13.3197C2.955 13.6753 3.4743 13.875 4.01579 13.875C4.55727 13.875 5.07658 13.6753 5.45946 13.3197C5.84235 12.9642 6.05746 12.482 6.05746 11.9792V2.77083C6.05746 2.26803 5.84235 1.78581 5.45946 1.43028C5.07658 1.07474 4.55727 0.875 4.01579 0.875Z" fill="inherit"/>
            <path d="M10.4323 0.875C9.89081 0.875 9.3715 1.07474 8.98862 1.43028C8.60573 1.78581 8.39062 2.26803 8.39062 2.77083V11.9792C8.39063 12.482 8.60573 12.9642 8.98862 13.3197C9.3715 13.6753 9.89081 13.875 10.4323 13.875C10.9738 13.875 11.4931 13.6753 11.876 13.3197C12.2589 12.9642 12.474 12.482 12.474 11.9792V2.77083C12.474 2.26803 12.2589 1.78581 11.876 1.43028C11.4931 1.07474 10.9738 0.875 10.4323 0.875Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_1987_889">
            <rect width="14" height="13" fill="white" transform="translate(0.224121 0.875)"/>
            </clipPath>
        </defs>
        </svg>
    `,
            }}
        />
    )
}
